import { render, staticRenderFns } from "./DtPedidos.vue?vue&type=template&id=232c7abe"
import script from "./DtPedidos.vue?vue&type=script&lang=js"
export * from "./DtPedidos.vue?vue&type=script&lang=js"
import style0 from "./DtPedidos.vue?vue&type=style&index=0&id=232c7abe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports